import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["input", "hidden", "patientLink", "newRecord"];

  connect() {
    const iconAppointment = $(".icon-appointment")
    let selected = null;
    let $typeahead = $(this.inputTarget)
      .typeahead(
        {},
        {
          display: "name",
          limit: 25,
          source: _.debounce((query, syncResults, asyncResults) => {
            if (query.length < 2) {
              return
            }
            iconAppointment.show()
            $.get(`${this.data.get("url")}`, {term: query}, function(data) {
              asyncResults(data);
            }).done(function () {
              iconAppointment.hide()
            });
            if (this.hasNewRecordTarget) {
              this.newRecordTarget.setAttribute(
                "href",
                `${this.newRecordTarget.dataset.href}?patient_full_name=${encodeURIComponent(query)}`
              )
            }
          }, 500),
          templates: {
            suggestion: function(data) {
              let patient_meta = "";
              if (data.cellphone) {
                patient_meta += `${data.cellphone} `;
              }
              if (data.cpf) {
                patient_meta += `CPF: ${data.cpf}`;
              }

              let patient_photo = "";
              if (data.photo) {
                patient_photo = `<img src="${
                  data.photo
                }" class="typeahead-patient-photo">`;
              } else {
                patient_photo = `<div class="typeahead-patient-initial">${data.name.charAt(
                  0
                )}</div>`;
              }

              return `<div class="clearfix"><div class="tw-flex">${patient_photo}<div class="typeahead-text"><div class="typeahead-name"> ${
                data.name
              }</div><div class="typeahead-meta">${patient_meta}</div></div></div></div>`;
            },
            notFound: function({query}){
              return [
                '<div class="typeahead-not-found">',
                query.length >= 2 ? "Nenhum paciente encontrado" : "Digite pelo menos 2 caracteres",
                "</div>"
              ].join("\n")
            }
          }
        }
      )
      .bind("typeahead:select typeahead:autocomplete", (e, data) => {
        if (this.data.get("type") == "modal") {
          selected = data;
          $(this.hiddenTarget).val(data.id);
          if (this.hasPatientLinkTarget) {
            $(this.patientLinkTarget)
              .attr("href", data.patient_path)
              .removeClass("hidden");
          }

          if (
            data.cellphone == null ||
            data.cellphone == "" ||
            data.reminder_preference == "dontreceive"
          ) {
            if (data.cellphone == null || data.cellphone == "") {
              $("#appointment-patient-no-reminder-cellphone").removeClass("hidden");
            }
            if (data.reminder_preference == "dontreceive") {
              $("#appointment-patient-no-reminder").removeClass("hidden");
            }
            $("#send-reminder-check").hide();
          } else {
            $("#send-reminder-check").show();
            $("#appointment-patient-no-reminder-cellphone").addClass("hidden");
            $("#appointment-patient-no-reminder").addClass("hidden");
          }
        }

        if (this.data.get("type") == "link") {
          window.location.href = data.patient_path;
        }

        const selectedEvent = new Event('selected-patient');
        selectedEvent.patient = data
        selectedEvent.patientFullNameInput = e.currentTarget
        if (this.hasHiddenTarget) {
          this.hiddenTarget.dispatchEvent(selectedEvent);
        }
      })
      .bind("typeahead:change", (e, term) => {
        if (this.data.get("type") == "modal") {
          if (!selected || selected.name != term) {
            $typeahead.typeahead("val", "");
            $(this.hiddenTarget).val("");
            if (this.hasPatientLinkTarget) {
              $(this.patientLinkTarget)
                .attr("href", null)
                .addClass("hidden");
              selected = null;
            }
          }
        }
      })
      if (!$('form').attr('action').match(/\d+/g)) $typeahead.bind("typeahead:change", (e, term) => {}).focus();
  }

  teardown() {
    $(".tt-input").typeahead("destroy");
  }
}
